import { render, staticRenderFns } from "./SapTable.vue?vue&type=template&id=cc635ae8"
import script from "./SapTable.vue?vue&type=script&lang=js"
export * from "./SapTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports